import { LastMessageText } from '@halo/ui-chat-react';
import type { MsgMediaCallContentProps } from './msg-media-call-content';
import { MsgMediaCallContent } from './msg-media-call-content';

export interface MsgMediaCallPreviewProps extends MsgMediaCallContentProps {}

export const MsgMediaCallPreview = memo(function MsgMediaCallPreview({
  message,
}: MsgMediaCallPreviewProps) {
  return (
    <LastMessageText>
      <MsgMediaCallContent message={message} />
    </LastMessageText>
  );
});
